import script from "./WechatLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./WechatLogin.vue?vue&type=script&setup=true&lang=ts"

import "./WechatLogin.vue?vue&type=style&index=0&id=dedfd710&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dedfd710"]])

export default __exports__